import React, { useState, useEffect } from 'react'

import { useGetAdminProcedureQuery } from '../Redux/Admin_Tasks/AdminProcedureSlice'; 
import GenericTableforArrayofObjects from '../GenericComponents/GenericTableforArrayofObjects';
import { getBaseUrl } from '../Utils';
import { useRunAdminProcedureMutation } from '../Redux/Admin_Tasks/AdminProcedureSlice';
import { Skeleton } from '../GenericComponents/Skeleton'
import { useTitleContext } from "../Hooks/useTitleContext";
import { useNavigate } from 'react-router-dom';


 const GetAdminProcedure: React.FC = () => {
  const navigate = useNavigate();
  interface AdminToolItem {
    Guid: string;
    SPName: string;
    Description: string;
  }

    const { setTitle } = useTitleContext();
    setTitle("Data Sources");

  const { data = [],isLoading, error} = useGetAdminProcedureQuery() as {
    data: AdminToolItem[];
    error: unknown;
    isLoading: boolean;
  };
  const [runAdminProcedure] = useRunAdminProcedureMutation();
  const handleRunClick = (guid: string) => {
    navigate(`#ManageAdminTools/run?Guid=${guid}`);
    runAdminProcedure({ Guid: guid })
      .unwrap()
      .catch((error) => {
        console.error("API call failed:", error);
      });
  };
  
        const FilteredColumnsData = data.length > 0 
        ? data.map(item => ({
            Name: item.SPName,
            Description: item.Description,
            Options: (
                <a
                    type="button"                         
                    id={item.Guid}
                    className="btn btn-custom btn-sm go-to-run-tool"
                     href="#"
                     onClick={(e) => { 
                        e.preventDefault(); 
                        handleRunClick(item.Guid || ""); 
                      }}    
                >
                Run
                </a>         
            ),
        }))
        : [{
            Name: "",
            Description: "",
            Options: "",
            Error : "No procedure found"
        }];
        
  return (
    
      <div>
     <Skeleton loading ={isLoading} height = '30px' width='100%'>

        <div className="include-bootstrap" id="adminTool-manager">
            <div className="">
                <div className="content">
                    <div className="float-right margin-top-small">
                        <a id="link_backto_admin_tasks" href="#AdminTasks">
                            &laquo; Back to Admin Tasks
                        </a>
                    </div>

                    <div className="header">Manage Admin Procedures</div>
                    <div className="padding-top-medium"></div>
                   
                </div>
            </div>
        </div>
        </Skeleton>
          <div className="float-right">
              <span className="sub-info">{data.length}</span>
              <span className="sub-info"> procedures</span>
          </div>
          <Skeleton loading ={isLoading} height = '30px' width='100%'>

          <GenericTableforArrayofObjects items={FilteredColumnsData} />
          </Skeleton>

      </div>
     
  );

}
        
//}
 

//};
export default GetAdminProcedure;
